<template>
  <div class="contacts-view">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'ContactsView',
  components: {},
  beforeRouteEnter (to, from, next) {
    next(to.matched.length !== 1)
  },
  beforeRouteUpdate (to, from, next) {
    next(to.matched.length !== 1)
  }
}
</script>
